<template>
  <div>
    <div class="search-bar-wrapper m-auto">
      <div
        :class="[isFocused ? '': '']"
        class="search-bar-inner-wrapper position-relative mt-20">
        <input
          ref="input"
          v-model="searchQuery"
          :class="[searchQuery!='' ? 'remove-focus': 'add-focus']"
          type="search"
          placeholder="Search"
          class="bm-input py-6 pe-32 ps-32 fs-14 rounded rounded-4 w-100"
          @keydown.enter.stop="changeQueryValue">
        <div
          :class="[isFocusedOut ? 'active-search':'']"
          class="search-icon position-absolute">
          <icon name="search"/>
        </div>
        <div
          :class="[searchQuery !='' ? 'd-block': 'd-none']"
          class="close-icon position-absolute"
          @click="clearValue">
          <icon
            name="close-icon"
          />
        </div>
      </div>
    </div>
    <div
      id="stock-videos'"
      class="thumbnail-box-conatiner mt-20"
      @scroll="stockVideoDivScroll">
      <Spinner
        v-show="loader"
        :speed="1"
        style="background-color: white;"
        size="huge"
        message="Loading..."
        class="position-absolute inner-Loader"/>
      <div
        v-masonry
        id="videoStockMasonry"
        class="image-container"
        transition-duration="0"
        item-selector=".image-wrapper"
        gutter="10" >

        <div
          v-masonry-tile
          v-for="(video) in videosFiltered"
          :key="video.Id"
          :class="video.AudioUrl != null && video.AudioUrl !='' ? 'hasAudi' : ''"
          class="image-wrapper">
          <div
            class="image-item thumbnail-border"
            @click="insertVideoToCanvas(video)">
            <div class="play-icon">
              <i class="fa fa-play-circle"/>
            </div>
            <img
              :src="video.ThumbnailVirtualPath"
              style="width: 100%" >
          </div>
        </div>
        <div
          :class="[videosFiltered && (videosFiltered.length == 0) ? 'd-block' : 'd-none']"
          class="fs-15 text-danger fw-bold text-center">
          No Results Matched
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from 'vue-simple-spinner';
import EventBus from '../../EventBus';
import ApplicationEventTypes from '../../mixins/ApplicationEventTypes';


export default {
  components: { Spinner },
  data() {
    return {
      searchQuery:    '',
      isFocused:      false,
      isFocusedOut:   false,
      imageData:      {},
      loader:         false,
      videos:         [],
      filteredVideos: {},
      pageNo:         1,
    };
  },
  computed: {
    videosFiltered() {
      return this.videos;
    },
  },
  mounted() {
    this.fetchStockVideos();
  },
  methods: {
    clearValue() {
      this.searchQuery       = '';
      this.isFocused         = false;
      this.$refs.input.value = '';
      this.videos            = [];
      this.pageNo            = 1;
      this.fetchStockVideos();
    },
    stockVideoDivScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      if ((scrollTop + offsetHeight) >= scrollHeight) {
        this.pageNo++;
        this.fetchStockVideos();
      }
    },
    changeQueryValue(event) {
      this.searchQuery = event.target.value;
      if (this.searchQuery.length >= 3) {
        this.videos = [];
        this.pageNo = 1;
        this.fetchStockVideos();
      }
    },
    fetchStockVideos() {
      this.loader     = true;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetVideosByBank&domainURL=https://${domainUrl}.com/&bankId=AEE06AD4-4415-4388-ACB5-D81DA0698C84&keyword=${this.searchQuery.length >= 3 ? this.searchQuery : 'video'}&pageNo=${this.pageNo}`;

      const config = {
        method:        'get',
        maxBodyLength: Infinity,
        url,
        headers:       { },
      };

      axios.request(config)
        .then((response) => {
          const parser              = new DOMParser();
          const xmlParsed           = parser.parseFromString(response.data, 'text/xml');
          let videoCollectionResult = xmlParsed.getElementsByTagName('SearchVideosByBankResult');

          videoCollectionResult[0] && (videoCollectionResult = videoCollectionResult[0].innerHTML);
          const videoResult = JSON.parse(videoCollectionResult);
          this.videos.push(...videoResult.Items);
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
        });
    },
    insertVideoToCanvas(videoObj) {
      if (this.$store.getters.getDisplayAddVideoModal) {
        let videoData = {
          Id:           '',
          Name:         videoObj.Name,
          videoDetails: {
            VideoSourceUrl: videoObj.LowResUrl,
            duration:       videoObj.Duration,
            width:          videoObj.Width,
            height:         videoObj.Height,
            mimeType:       'video/mp4',
            audio:          (!videoObj.AudioUrl || videoObj.AudioUrl.length < 10) ? 'https://video-processing.bankmarketingcenter.com/ffmpeg-video/audio-6ybTJmVkIN.mp3' : videoObj.AudioUrl,
            videoHighRes:   videoObj.HighResUrl,
          },
          AlternativeVideoUrlsResVersion: [],
        };

        videoData.AlternativeVideoUrlsResVersion.push(videoObj);
        EventBus.$emit('AddNewVideoOnCanvas', videoData);
        EventBus.$emit('SetPageVideoLength', videoObj.Duration);
        this.$store.commit('setDisplayAddVideoModal', false);
        this.$store.commit('setIsVideoModel', false);
        return;
      }
      EventBus.$emit(ApplicationEventTypes.ImageObjectEvents.SELECTED_VIDEO_FOR_LEFT_PANEL, videoObj);
    },
  },
};
</script>

<style lang="scss" scoped>
  .custom-icon{
    width: auto !important;
  }
  .play-icon{
    position: absolute;
    top: 0;
    left: 0;
    font-size: 50px;
    color: white;
    width: 100%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0000001f;
    cursor: pointer;
  }
.thumbnail-box-conatiner{
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding:0px 20px;

  .image-container{
    /*column-width: 14vw;
    grid-auto-flow: dense;*/
    margin-top: 10px;
    min-height: 412px;
    .image-wrapper{
      width:calc(25% - 10px);
      margin-bottom: 20px;
    }
    .video-item{
      transition: all 0.2s;
      cursor: pointer;
      position: relative;
      margin-bottom: 10px;
      float: left;
      &:hover{
        .image-delete-button{
          opacity: 1 !important;
        }
      }
      .image-delete-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 3px;
        opacity: 0;
        height: 24px;
        width: 24px;
      }

      video, img {
        &:hover{
          box-shadow: 0 0 8px 4px rgba(0,0,0,0.2);
          opacity: 1;
        }
        width: 100%;
        margin-bottom: 0;
        border-radius: 10px !important;
        float: left;
      }
      .thumbnail-border{
        border: 2px solid #3bb0fa!important
      }
    }


  }
  .inner-Loader {
    width: calc(100% - 80px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 56;
    top: 210px;
    bottom: 2vh;

    .vue-simple-spinner-text{
      color: #52A7E1 !important
    }
  }
}

.hasAudio{
  position: relative;
  &:after{
    content: "\f028";
    font: normal normal normal 14px/1 FontAwesome;
    color: white;
    position: absolute;
    right: 10px;
    top: 6px;
    font-size: 26px;
  }
}


</style>
